module.exports = __webpack_public_path__ + "img/3.42693e07.jpg";